module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/polling-data/polling-data.component.scss
// module id = ./src/app/polling-data/polling-data.component.scss
// module chunks = main